<template>
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <v-card flat color="transparent" class="mb-4">
      <v-card-title class="font-weight-bold q-message">{{ `${qMessage}` }}</v-card-title>
      <v-card-text class="headline pt-5 pl-10">
        <span>{{ body }}</span>
        <br />
        <br />
        <span v-if="qTitle === 'landing'">확인 버튼을 누르고 설문을 시작해주세요</span>
        <!-- <span v-else>확인 버튼을 눌러서 다음 설문을 시작해주세요</span> -->
      </v-card-text>
    </v-card>
    <v-card-actions>
      <v-btn color="#5878b8" :disabled="!valid" width="100" class="headline white--text" @click="confirm">
        확인
        <v-icon right>mdi-check</v-icon>
      </v-btn>
      <!-- <v-btn text color="grey" class="title" v-if="valid">
        Enter 키를 눌러주세요
        <v-icon>mdi-keyboard-return</v-icon>
      </v-btn> -->
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  props: {
    body: {
      type: String,
      default: '',
    },
    qId: {
      type: String,
      default: '',
    },
    qNumber: {
      type: String,
      default: 'qNumber',
    },
    qMessage: {
      type: String,
      default: '',
    },
    qTitle: {
      type: String,
      default: '',
    },
    qPredicate: {
      type: String,
      default: '',
    },
    emailType: {
      type: Boolean,
      default: false,
    },
    maxText: {
      type: Number,
      default: 10,
    },
  },
  mounted() {
    if (this.qId === '일반-기본-1') this.answer = this.userNick
    if (this.qId === '일반-기본-2') this.answer = this.userEmail
  },
  data() {
    return {
      valid: true,
      answer: '',
      lazy: false,
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        counter: (value) => value.length <= 20 || '최대 20 글자까지 해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    ...mapMutations(['setUserEmail', 'setUserNick', 'setMaster']),
    confirm() {
      const classId = this.$route.params.classId
      this.valid && this.$emit('nextSlide')
      if (this.qId === '일반-기본-1') this.setUserNick(this.answer)
      if (this.qId === '일반-기본-2') this.setUserEmail(this.answer)
      if (this.qId === '일반-기본-end') this.$router.push('/' + classId + '/life')
      if (this.qId === '라이프-end') this.$router.push('/' + classId + '/finance')
      if (this.qId === '재무-end') this.$router.push('/' + classId + '/career')
      if (this.qId === '커리어-end') this.$router.push('/' + classId + '/action')
      if (this.qId === '액션플랜-end') this.$router.push('/' + classId + '/score/master')
    },
  },
  computed: {
    ...mapState(['userEmail', 'userNick', 'master']),
  },
}
</script>

<style></style>
